import React, { useState, useRef } from 'react';

const Card = ({ children, className = "", onClick }) => (
  <div 
    onClick={onClick}
    className={`bg-white rounded-3xl border border-slate-200/50 shadow-sm transition-all duration-300 ${onClick ? 'cursor-pointer hover:shadow-lg hover:border-indigo-200/50 hover:-translate-y-1' : ''} ${className}`}
  >
    {children}
  </div>
);
export default Card;